import Link from "next/link";
import { useTranslation } from "react-i18next";

import { ROUTE } from "@/route/app_routes.js";

const POINT_ICONS = ["feather-code", "feather-users", "feather-award", "feather-trending-up"];
const POINT_KEYS = ["learnByBuilding", "learnWithOthers", "earnCertificate", "growCareer"];
const POINT_DEFAULTS = [
  { label: "Learn by building", desc: "Real projects, not slideshows" },
  { label: "Learn with others", desc: "A community of real learners" },
  { label: "Earn a certificate", desc: "Shareable when you finish" },
  { label: "Grow your career", desc: "Skills that map to real jobs" },
];

const ReimagineCareer = () => {
  const { t } = useTranslation("home");

  const points = POINT_KEYS.map((key, i) => ({
    icon: POINT_ICONS[i],
    label: t(`reimagineCareer.points.${key}.label`, POINT_DEFAULTS[i].label),
    desc: t(`reimagineCareer.points.${key}.desc`, POINT_DEFAULTS[i].desc),
  }));

  return (
    <div className="rbt-reimagine">
      <div className="container">
        <div className="rbt-reimagine__grid">
          <div className="rbt-reimagine__copy">
            <span className="rbt-eyebrow rbt-eyebrow--light">
              <span className="rbt-eyebrow-dot" aria-hidden="true" />
              {t("reimagineCareer.eyebrow", "For every stage of your journey")}
            </span>
            <h2 className="rbt-reimagine__title">{t("reimagineCareer.title", "Reimagine your career in tech")}</h2>
            <p className="rbt-reimagine__desc">
              {t(
                "reimagineCareer.desc",
                "Whether you're writing your first line of code or shipping production systems, SmartTech Academy has a free, structured path built around real work — not just theory."
              )}
            </p>

            <div className="rbt-reimagine__points">
              {points.map((point) => (
                <div className="rbt-reimagine__point" key={point.label}>
                  <span className="rbt-reimagine__point-icon">
                    <i className={point.icon}></i>
                  </span>
                  <span>
                    <strong>{point.label}</strong>
                    <span>{point.desc}</span>
                  </span>
                </div>
              ))}
            </div>

            <Link className="rbt-btn btn-white icon-hover radius-round" href={ROUTE.course}>
              <span className="btn-text">{t("reimagineCareer.exploreCourses", "Explore courses")}</span>
              <span className="btn-icon"><i className="feather-arrow-right"></i></span>
            </Link>
            <span className="rbt-reimagine__note">{t("reimagineCareer.note", "100% free — no credit card, ever.")}</span>
          </div>

          <div className="rbt-reimagine__visual" aria-hidden="true">
            <div className="rbt-reimagine__tile rbt-reimagine__tile--code">
              <div className="rbt-reimagine__tile-dots">
                <span /><span /><span />
              </div>
              <pre>
<code><span className="tok-kw">const</span> you = {"{"}{"\n"}  skills: [<span className="tok-str">&quot;{t("reimagineCareer.codeShipped", "shipped")}&quot;</span>],{"\n"}  hired: <span className="tok-kw">true</span>{"\n"}{"}"};</code>
              </pre>
            </div>
            <div className="rbt-reimagine__tile rbt-reimagine__tile--stat">
              <strong>35+</strong>
              <span>{t("reimagineCareer.freeCourses", "Free courses")}</span>
            </div>
            <div className="rbt-reimagine__tile rbt-reimagine__tile--icon">
              <i className="feather-zap"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReimagineCareer;
